import { EMPTY_FIELD } from 'constants/emptyField';

import { Link } from 'shared/react-admin/Links/Link';
import { Commission } from 'types/embedded/commission';

import { getRelatedCommissionsLinkParams } from './utils/getRelatedCommissionsLinkParams';

type Props = {
  record?: Commission;
};

export const RelatedCommissionsLink: React.FC<Props> = ({ record }) => {
  const linkParams = getRelatedCommissionsLinkParams(record);

  if (!linkParams) {
    return <>{EMPTY_FIELD}</>;
  }

  return (
    <Link to={linkParams} underline="always">
      Перейти
    </Link>
  );
};
